import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { Trend, type TrendProps } from "@/molecules/Trend"
import CardDashboardTemplate from "@/pages/DashboardPage/components/templates/CardDashboardTemplate"
import { useSensorsCount } from "@/pages/DeploymentsPage/application/useDeployments"
import { BaselineUsageGraph } from "./BaselineUsageGraph"
import { EmptyStateWidget } from "./EmptyStateWidget"
import { EnvironmentDropdown } from "./EnvironmentDropdown"
import { StatisticWidget } from "./StatisticWidget"
import { WidgetTemplate } from "./WidgetTemplate"

import styles from "./HeaderDeploymentsTab.module.scss"

export const AverageUsageWidget = () => {
  const { t } = useTranslation()
  const { t: tWidgets } = useTranslation("translation", {
    keyPrefix: "deployments.widgets"
  })
  const { intlNumber } = useNumberConvertor()
  const [{ response, isLoading }, state] = useSensorsCount()

  const { averageLiveCount = 0, trendPercentage = 0 } = response || {}
  let variant: TrendProps["variant"] =
    trendPercentage === 0 ? "equal" : undefined

  if (!variant) variant = trendPercentage > 0 ? "up" : "down"

  const noUsageData = averageLiveCount === 0 && !isLoading

  return (
    <CardDashboardTemplate
      loading={isLoading}
      className={{ card: styles.card }}
      title={
        <Heading
          level={5}
          title={tWidgets("baseline.title")}
          popover={{
            content: tWidgets("baseline.popover")
          }}
        />
      }
      aside={<EnvironmentDropdown state={state} />}
    >
      <EmptyStateWidget noUsageData={noUsageData}>
        <WidgetTemplate
          verticalGap={4}
          Component={BaselineUsageGraph}
          componentProps={response}
        >
          <StatisticWidget
            title={tWidgets("baseline.averagePerDay")}
            value={intlNumber(averageLiveCount)}
            suffix={capitalizeFirstLetter(
              t("general.sensor", { count: averageLiveCount })
            )}
          />
          {variant !== "equal" && (
            <Trend variant={variant} percentage={trendPercentage} />
          )}
        </WidgetTemplate>
      </EmptyStateWidget>
    </CardDashboardTemplate>
  )
}
